import { useEffect } from 'react';
import {
  clearBusinessContext,
  getPortalReturnUrl,
  getPortalRole,
  getStaffLoginUrl,
} from '../app/businessContext';

function UnauthorizedPage() {
  const portalRole = getPortalRole() || 'current';
  const isStaffPage = window.location.pathname.startsWith('/staff');
  const isStaffRole = portalRole === 'staff' || isStaffPage;
  const staffLoginUrl = getStaffLoginUrl();
  const destination = isStaffRole ? staffLoginUrl : getPortalReturnUrl();

  useEffect(() => {
    if (!isStaffPage) {
      return;
    }

    clearBusinessContext();
    window.location.replace(staffLoginUrl);
  }, [isStaffPage, staffLoginUrl]);

  function handleReturn() {
    clearBusinessContext();
    window.location.href = destination;
  }

  return (
    <main className="relative min-h-screen overflow-hidden bg-[#f7f2eb] text-[#1f1812]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(156,119,75,0.22),_transparent_34%),radial-gradient(circle_at_bottom_right,_rgba(89,126,102,0.16),_transparent_30%),linear-gradient(180deg,_var(--theme-surface-muted)_0%,_#f1e7da_100%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-6xl items-center px-4 py-10 sm:px-6 lg:px-8">
        <section className="grid w-full gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
          <div className="rounded-[36px] border border-[#e7d8c8] bg-[rgba(255,250,245,0.78)] p-7 shadow-[0_24px_80px_rgba(var(--theme-shadow-rgb),0.12)] backdrop-blur sm:p-10">
            <p className="m-0 text-xs font-semibold uppercase tracking-[0.22em] text-[#9b6b3f]">
              Access restricted
            </p>
            <h1 className="mt-4 max-w-2xl text-3xl font-semibold tracking-[-0.05em] text-[#221711] sm:text-5xl">
              This Seaweeds page is not available for your account.
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-7 text-[#6f5b4d] sm:text-base">
              You are signed in with a {portalRole} account. Please continue from the
              correct e-Portal entry so Seaweeds can load the pages assigned to your role.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button
                className="rounded-full bg-[#1f5c4d] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#18493d]"
                onClick={handleReturn}
                type="button"
              >
                {isStaffRole ? 'Back login' : 'Back to e-Portal'}
              </button>
            </div>
          </div>

          <aside className="rounded-[32px] border border-[#eadfce] bg-[rgba(255,255,255,0.76)] p-6 shadow-[0_18px_60px_rgba(var(--theme-shadow-rgb),0.08)] backdrop-blur sm:p-8">
            <div className="rounded-[28px] bg-[#2f241d] p-6 text-[#f6ede3] sm:p-8">
              <p className="m-0 text-xs font-semibold uppercase tracking-[0.18em] text-[#d8b891]">
                Session check
              </p>
              <div className="mt-6 space-y-4">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                  <p className="m-0 text-xs uppercase tracking-[0.14em] text-[#c7b19a]">Role</p>
                  <p className="mt-2 text-lg font-semibold text-white">{portalRole}</p>
                </div>
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
                  <p className="m-0 text-xs uppercase tracking-[0.14em] text-[#c7b19a]">
                    What to do next
                  </p>
                  <p className="mt-2 text-sm leading-6 text-[#f0e2d3]">
                    Open Seaweeds from the matching e-Portal menu so the required business
                    context and access token are included.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </section>
      </div>
    </main>
  );
}

export default UnauthorizedPage;
